var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "title",
        class: { removeVerticalMargin: _vm.removeVerticalMargin }
      },
      _vm.$listeners
    ),
    [
      _vm.title ? _c("h1", [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(),
      _vm.subtitle
        ? _c("span", [_vm._v(" " + _vm._s(_vm.subtitle) + " ")])
        : _vm._e(),
      _vm.underlined
        ? _c("div", { staticClass: "decoration-underline-title" })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }